import { Component, OnInit, Input } from '@angular/core';
import { StepperTemplate } from './stepper-template';

@Component({
  selector: 'stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  @Input() template: StepperTemplate;


  constructor() {
  }

  ngOnInit() {

  }
  getStepClass = (step: any) => {
    return 'step';
  }
  //append list of steps to Stepper; if index included, insert step at index position


  //advance to next step in list
  public next() {

  }

}
